import { render, staticRenderFns } from "./GroupStatusFilter.vue?vue&type=template&id=b2138e56&scoped=true&"
import script from "./GroupStatusFilter.vue?vue&type=script&lang=js&"
export * from "./GroupStatusFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2138e56",
  null
  
)

export default component.exports